import { EtapaRastreio } from "./etapa-rastreio";
import { Rastreio } from "./rastreio";
import { RastreioLog } from "./rastreio-log";

export class RastreioDTO {
  idCupom: string;
  rastreio: Rastreio[];
  etapasRastreio: EtapaRastreio[];
  logsRastreio: RastreioLog[];
}
